import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_encounter_list = _resolveComponent("encounter-list")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_vital_signs = _resolveComponent("vital-signs")!
  const _component_doctor_orders = _resolveComponent("doctor-orders")!
  const _component_doctor_documents = _resolveComponent("doctor-documents")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "ma-0",
    flat: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
        color: "primary",
        centered: "",
        stacked: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_tab, {
            value: "tab-1",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-view-list-outline")
                  ]),
                  _: 1
                }),
                _createTextVNode(" Encounters ")
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "tab-2",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-pulse")
                  ]),
                  _: 1
                }),
                _createTextVNode(" Vitals ")
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "tab-3",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-diabetes")
                  ]),
                  _: 1
                }),
                _createTextVNode(" Orders ")
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_tab, {
            value: "tab-4",
            density: "compact"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-file-sign")
                  ]),
                  _: 1
                }),
                _createTextVNode(" Documents ")
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_window, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, { value: "tab-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_encounter_list, { patient: _ctx.patient }, null, 8, ["patient"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "tab-2" }, {
            default: _withCtx(() => [
              _createVNode(_component_vital_signs, { patient: _ctx.patient }, null, 8, ["patient"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "tab-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_doctor_orders)
            ]),
            _: 1
          }),
          _createVNode(_component_v_window_item, { value: "tab-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_doctor_documents)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}